import "./About.css";
import profile from "./images/profile.jpg"
import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import "react-photo-album/masonry.css";

export default function About() {
    return (
        <div className="About">
            <div className="About-body">
                <body>
                    <div className="About-content">
                        <Link to="/" className="Back"><p>&lt;back to home&gt;</p></Link>
                        <TypeAnimation
                            sequence={[700, "Hi!", 1000, "Hi! My name's Tate."]}
                            wrapper="span"
                            speed={50}
                            style={{ fontSize: "2em", display: "inline-block", fontWeight: 600, marginBottom: 30, marginTop: 45 }}
                        />
                        <div className="Description">

                            <div className="Top-box">
                                <img className="Profile-img" src={profile} alt="profile-pic" />
                                <div className="Top-right-box">
                                    <h2>I'm a student, programmer and professional nerd.</h2>

                                </div>
                            </div>
                            <p>&emsp;I'm an incoming MIT freshman who hails from the Texas Panhandle. I will attend MIT starting the fall of 2026. I have a passion for Computer Science, Robotics, and AI. I've pursued these interests by starting my own IT business where I built websites, ran the social media for a national conference, and installed IT equipment for an entire hotel.</p>

                            <div className="First-para-box">
                                <p>&emsp;I've been recognized as a U.S. Dept. of Education Presidential Scholars Semifinalist, a LinkedIn Possibilities in Tech Scholar, a MIT Introduction to Engineering and Science Semester Scholar, and a National Merit Scholar. I've also had the high honor of being selected for a Horatio Alger Scholarship, a Foundation for Rural Service Scholarship, and a NHS Scholarship.</p>
                                <img className="Linkedin-img" src="/photos/linkedin.jpg" alt="linkedin" />
                            </div>


                            <p>&emsp;Throughout High School I've competed in Texas UIL Computer Science competitions, and I've placed fifth in the state. I also competed in FTC Robotics where I was the lead programmer for my school's robotics program. As well as school robotics, I taught fundamentals of robotics to elementary kids every year in a 6 week boot camp I run through my local 4-H. I also serve as a Texas 4-H STEM Ambassador, where I was selected to manage the video production teams of the State Texas 4-H Assemblies. For more info on what I've done, check out my resume on the home page.</p>

                            <p>&emsp;As I look forward to college, I intend on studying these fields further. If you are interested in contacting me, you can email me at t8wilhelm(at)gmail.com or tatew(at)mit.edu.</p>
                            <img className="Graduation-img" src="/photos/graduation.jpg" alt="graduation" />
                        </div>
                    </div>
                </body>
            </div>
        </div>
    );
}